import React, { Component } from "react";
import { upgradeLevel } from "../../../lib/api/affiliate";
import { showNotification } from "../../../lib/helper";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { fetchingUser, fetchingUserSuccess, updateMemberAction } from "../../../redux/actions";
import { useSnackbar } from "notistack";
export class Upgrade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rank: this.getRankNumberFirstTime(props.userRank),
    };
  }

  getRankNumberFirstTime(rank) {
    const rankString = {
      rank1: 1,
      rank2: 2,
      rank3: 3,
      rank4: 4,
      rank5: 5,
      rank6: 6,
      rank7: 7,
    };
    return ++rankString[rank] || 2;
  }
  getRankNumber(rank) {
    const rankString = {
      rank1: 1,
      rank2: 2,
      rank3: 3,
      rank4: 4,
      rank5: 5,
      rank6: 6,
      rank7: 7,
    };
    return ++rankString[rank] || 1;
  }
  setRankString(number) {
    return `rank${number}`;
  }

  getRankIconForUser = (userRank) => {
    const urls = {
      rank1: "images/rank1.png",
      rank2: "images/rank2.png",
      rank3: "images/rank3.png",
      rank4: "images/rank4.png",
      rank5: "images/rank5.png",
      rank6: "images/rank6.png",
      rank7: "images/rank7.png",
      rank8: "images/rank8.png",
    };
    return urls[userRank] || null;
  };
  getCurrentRanking = () => {
    const { vip } = this.props.memberReducer;
    return vip.name;
  };

  getPriceByRankLevel = (rank) => {
    const available_rank = this.getRanksFromCurrent(rank);
    let price = 0;
    available_rank.forEach((rank) => {
      price += rank.price;
    });
    return price
  };
  getRanksFromCurrent = (rank) => {
    const { vips } = this.props.appReducer;
    const playerRank = this.getCurrentRanking()
    const currentRank = vips.findIndex((vip) => vip.name === playerRank);
    let available_rank = [];
    for (let i = currentRank + 1; i < rank; i++) {
      available_rank.push(vips[i]);
    }
    return available_rank;
  };
  getCurrentRanking1 = (rank) => {
    const rankString = {
      rank1: "Vip 1",
      rank2: "Vip 2",
      rank3: "Vip 3",
      rank4: "Vip 4",
      rank5: "Vip 5",
      rank6: "Vip 6",
      rank7: "Vip 7",
    };
    return rankString[rank] || null;
  }
  setVip = (type) => {
    const { enqueueSnackbar } = this.props;
    switch (type) {
      case "+":
        if (this.state.rank >= 7) return;
        this.setState({ rank: this.state.rank + 1 }, () => {
          this.getPriceByRankLevel(this.state.rank);
        });
        break;
      case "-":
        if (this.state.rank <= 1) return;
        this.setState({ rank: this.state.rank - 1 }, () => {
          this.getPriceByRankLevel(this.state.rank);
        });
        break;
      default:
        break;
    }
  }
  render() {
    let { vip_id, username } = this.props.memberReducer;
    let { enqueueSnackbar, t } = this.props;
    return (
      <div
        className="w-100 h-100"
        style={{
          minHeight: "calc(100vh - 120px)",
          backgroundImage: `url("/images/upgrade-agency-bg.png")`,
          backgroundSize: "cover",
          padding: "0 20px",
        }}
      >
        <div
          className=""
          style={{
            width: "241px",
            height: "46px",
            margin: "0 auto",
          }}
        >
          <img
            src="\images\icon\upgrade-agency.svg"
            alt=""
            style={{
              marginTop: "40px",
              width: "100%",
              height: "100%",
            }}
          />
        </div>
        <div
          style={{
            marginTop: "130px",
            marginBottom: "50px",
            padding: "0 16px",
          }}
        >
          <div
            style={{
              color: "white",
              maxWidth: "420px",
              padding: "15px",
              border: "1px solid #ffe1b0",
              borderRadius: "16px",
              background: "#242424",
              margin: "0 auto",
            }}
          >
            <div
              className="d-flex align-items-center"
              style={{
                gap: "8px",
                padding: "5px 10px",
                background: "#3A3A3A",
                borderRadius: "10px",
              }}
            >
              <img
                src={this.getRankIconForUser(this.props.userRank)}
                alt=""
                style={{
                  width: "60px",
                  height: "60px",
                }}
              />
              <div>
                <p style={{ fontWeight: 700 }}>{username}</p>
                <p> {this.getCurrentRanking()}</p>
              </div>
            </div>

            {this.props.userRank !== "rank7" && (
              <>
                <div>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>{t("Upgrade")} VIP</div>
                    <div
                      className="d-flex"
                      style={{
                        gap: "4px",
                      }}
                    >
                      <button
                        className="d-flex justify-content-center align-items-center"
                        disabled={vip_id + 1 ===
                          this.state.rank}
                        style={{
                          width: "33px",
                          height: "33px",
                          background: `${this.getRankNumber(this.props.userRank) <
                            this.state.rank
                            ? "#FFE1B0"
                            : "#454545"
                            }`,
                          borderRadius: "4px",
                        }}
                        onClick={() => this.setVip("-")}
                      >
                        -
                      </button>
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{
                          width: "75px",
                          height: "33px",
                          background: "#fff",
                          color: "black",
                          borderRadius: "4px",
                        }}
                      >
                        {this.getCurrentRanking1(
                          this.setRankString(this.state.rank)
                        )}
                      </div>
                      <button
                        className="d-flex justify-content-center align-items-center"
                        disabled={this.state.rank >= 7}
                        style={{
                          width: "33px",
                          height: "33px",
                          background: `${this.state.rank >= 7 ? "#454545" : "#FFE1B0"
                            }`,
                          borderRadius: "4px",
                        }}
                        onClick={() =>
                          this.setVip('+')
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>{t("UpgradeCharge")}</div>
                    <div>{this.getPriceByRankLevel(this.state.rank)}</div>
                  </div>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <div>{t("AmountF1BuyVip")}</div>
                    <div>1/{this.state.rank + 1}</div>
                  </div>
                </div>
                <div
                  style={{
                    marginTop: "20px",
                  }}
                >
                  <div>
                    <label htmlFor="">
                      <input
                        type="checkbox"
                        name=""
                        id=""
                        style={{ marginRight: "10px" }}
                      />
                      {t("AcknowledgeAndAgree")}{" "}
                      <span
                        style={{
                          textDecoration: "underline",
                        }}
                      >
                        {t("TermsOfService")}
                      </span>
                    </label>
                  </div>
                  <button
                    className="d-block"
                    style={{
                      color: "#242424",
                      background: "#FFE1B0",
                      width: "80%",
                      minHeight: "50px",
                      borderRadius: "6px",
                      margin: "0 auto",
                      textAlign: "center",
                      fontWeight: "bold",
                      marginTop: "20px",
                      cursor: "pointer",
                    }}
                    onClick={async () => {
                      const data = {
                        vip_level: this.state.rank,
                      };
                      const result = await upgradeLevel(data);

                      if (result.success) {
                        this.props.handleUpdateUserRank(this.state.rank);
                        showNotification(enqueueSnackbar, {
                          message: result.message,
                          type: "success",
                        });
                      } else {
                        showNotification(enqueueSnackbar, {
                          message: result.message,
                          type: "danger",
                        });
                      }
                    }}
                  >
                    {t("Upgrade")} {t("Rank")}
                  </button>
                </div>
              </>
            )}
            {this.props.userRank === "rank7" && (
              <p
                style={{
                  padding: "20px 0",
                  fontSize: "18px",
                  textAlign: "center",
                  lineHeight: "28px",
                }}
              >
                {t("YouHaveReachMaxLevel")}
              </p>
            )}
          </div>
        </div>
        <p
          style={{
            maxWidth: "647px",
            margin: "0 auto",
            color: "#ffe1b0",
            fontSize: "14",
          }}
        >
          {t("VipNotice")}
        </p>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    memberReducer: state.memberReducer,
    appReducer: state.appReducer
  };
}
const withSnackbar = (Component) => (props) => {
  const { enqueueSnackbar } = useSnackbar();
  return <Component {...props} enqueueSnackbar={enqueueSnackbar} />;
};
export default connect(mapStateToProps, {
  fetchingUser,
  fetchingUserSuccess,
  updateMemberAction
})(withRouter(withTranslation()(withSnackbar(Upgrade))));
